import { useQuery } from '@tanstack/react-query';
import { APIService } from '@services/api/common-services';
import { APICONFIG } from '@config/api.config';
import { IQueryResponse } from '@services/api';
import { ISSListAPIResponse } from '.';
import { getDatabase } from '@rxdb/config/databaseConfig';

interface UseSSDropdownQueryProps {
	enabled?: boolean;
}

export const useSSDropdownQuery = ({ enabled = true }: UseSSDropdownQueryProps = {}): IQueryResponse<
	ISSListAPIResponse[]
> => {
	const fetchSSList = async (): Promise<ISSListAPIResponse[]> => {
		const response = await APIService.getData<{ data: ISSListAPIResponse[] }>(APICONFIG.LMS_SS_LIST);
		const db = await getDatabase();
		const ssListCollection = db.lms_ss_list;
		await ssListCollection.bulkInsert(response.data);
		return response.data;
	};

	const { data, error, isLoading, isPending, refetch } = useQuery({
		queryKey: ['ssDropdown'],
		queryFn: fetchSSList,
		refetchOnWindowFocus: false,
		enabled,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		refetch,
	};
};
